/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Equal_Still_Cow_FryInputs */

const fr_equal_still_cow_fry = /** @type {(inputs: Equal_Still_Cow_FryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord`)
};

/**

* @param {Equal_Still_Cow_FryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const equal_still_cow_fry = /** @type {((inputs?: Equal_Still_Cow_FryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equal_Still_Cow_FryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_equal_still_cow_fry(inputs)
});